import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { StyledToobar } from "./DatePicker.style";
import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import { DATE_FORMATS } from "helper/date";

export default function DatePickerCM(props) {
  const position = window.innerWidth < 800 ? "top" : "right";
  const type = props.type ?? "Date";

  const plugins = {
    Date: [
      <DatePanel />,
      <StyledToobar
        names={{ close: "تایید", today: "امروز" }}
        position="bottom"
      />,
    ],
    Time: [
      <TimePicker hideSeconds />,
      <StyledToobar
        names={{ close: "تایید", today: "الان" }}
        position="bottom"
      />,
    ],
    Both: [<TimePicker hideSeconds />],
  };

  const format = {
    Time: DATE_FORMATS.faTime,
    Date: DATE_FORMATS.faDate,
    Both: DATE_FORMATS.faDateTime,
  };
  return (
    <DatePicker
      ref={props.useref}
      value={props.value}
      onChange={(val) => props.onChange(val)}
      calendar={persian}
      locale={persian_fa}
      calendarPosition={position}
      range={props.range}
      render={props.render}
      minDate={props.mindate}
      disableDayPicker={type === "Time"}
      format={format[type]}
      plugins={plugins[type]}
    />
  );
}
